import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, inject } from '@angular/core';
import { CustomDialogConfig } from '@app/interfaces/dialog-config.interface';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  private readonly dialogRef: DialogRef = inject(DialogRef);
  @Inject(DIALOG_DATA) public data: CustomDialogConfig = inject(DIALOG_DATA);

  public closeDialog($event?: MouseEvent): void {
    if (this.data.callback) {
      this.data.callback();
    }
    $event?.preventDefault();
    this.dialogRef.close();
  }
}
